import { Box, Button, IconButton, TextField, Typography } from '@astro-ui/components'
import theme from '@astro-ui/theme'
import { CloseCircle, Search } from '@astronautsid/wpe-icons'
import useProductDetail from './useProductDetail'
import Table from './Table'
import EmptyState from './EmptyState'

const ProductDetail = () => {
  const { isEdit, search, handleSearch, handleGoToAddProduct } = useProductDetail()

  return (
    <Box
      id="detail-produk"
      borderRadius="8px"
      border="1px solid"
      borderColor={theme.colors.border}
      backgroundColor={theme.colors.white}
      overflow="auto"
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        padding="24px"
        gap="32px"
      >
        <Typography variant="display-tiny" whiteSpace="nowrap">
          Detail Produk
        </Typography>

        {isEdit && (
          <Box display="flex" gap="16px" alignItems="center">
            <TextField
              placeholder="Cari Produk"
              value={search}
              onChange={(e) => {
                handleSearch(e.target.value)
              }}
              InputProps={{
                startAdornment: <Search />,
                endAdornment: search && (
                  <IconButton onClick={() => handleSearch('')}>
                    <CloseCircle size={18} />
                  </IconButton>
                ),
              }}
              sx={{ width: '220px' }}
            />

            {isEdit && <Button onClick={handleGoToAddProduct}>Tambah Produk</Button>}
          </Box>
        )}
      </Box>

      {isEdit ? <Table /> : <EmptyState />}
    </Box>
  )
}

export default ProductDetail
